import {
  flattenObject,
  patchObjectsByObjectId,
  SUB_EVENT_TYPES
} from '@/provider/utils';
import { useLazyQuery, useResult } from '@vue/apollo-composable';
import { getObjectPropertyByKey } from '@/provider/utils';
import itemsSchema from '../api/object-monitoring-items-list.graphql';
import { abcSort } from '@/compositions/sortBy';

export function useMonitoringItems({ object }) {
  const { id } = object;
  const { subscribeToMore, result, load } = useLazyQuery(
    itemsSchema.load,
    {
      objectId: id
    },
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only'
    }
  );

  const list = useResult(result, [], data =>
    data.objectsToObjects
      .map(i => {
        const property = getObjectPropertyByKey(i.object2, 'stateValue');
        const propertyAlert = getObjectPropertyByKey(i.object2, 'stateAlert');
        const obj = flattenObject(i.object2);
        if (!property.linkedPropertyId && property.value === undefined) {
          obj.stateValue = 'n/a';
        }
        return {
          statePropertyId: property.id,
          alertPropertyId: propertyAlert.id,
          linked: !!property.linkedPropertyId,
          propertyValueObject: property,
          ...obj
        };
      })
      .sort((a, b) => abcSort(a.name, b.name))
  );

  subscribeToMore({
    document: itemsSchema.listenMonitoringItemsList,
    variables: {
      objectId: id
    },
    updateQuery: (previousResult, { subscriptionData }) => {
      console.log('object monitoring items list subscription');
      const relatedNode = subscriptionData.data?.Objects?.relatedNode;
      const eventType = subscriptionData.data?.Objects?.event;
      if (eventType !== SUB_EVENT_TYPES.insert) return;
      if (!relatedNode) return;
      switch (relatedNode.__typename) {
        case 'ObjectsToObject': {
          return {
            objectsToObjects: [...previousResult.objectsToObjects, relatedNode]
          };
        }
        case 'ObjectProperty': {
          const { objectId } = relatedNode;
          const patchedObjects = patchObjectsByObjectId(
            objectId,
            'objectProperties',
            relatedNode,
            previousResult.objects
          );

          if (patchedObjects) {
            return {
              objects: patchedObjects
            };
          }
        }
      }
    }
  });

  return {
    load,
    list
  };
}
